import { ILogoTheme } from './types';

export const theme: ILogoTheme = {
  reversedColor: false,
  height: 'full',
};

export const themeLgDesktop: ILogoTheme = {
  height: 'full',
  reversedColor: false,
};
